module.exports = __webpack_public_path__ + "fi-rainforest-alliance-cocoa-d7529819b90c6b4dcdf7ce7dc5a720ae.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-rainforest-alliance-cocoa.png
// module id = 86
// module chunks = 0